import { siteMetadata } from 'config'

const { apiHost } = siteMetadata

export const login = async (userId, password) => {
  try {
    const response = await fetch(`${apiHost}/api/v1/internal/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: userId.trim(),
        password: password.trim(),
      }),
      credentials: 'include',
    })

    if (response.status === 200) {
      const {
        id,
        name,
        is_admin: isAdmin = false,
        expires = null,
      } = await response.json()
      return {
        id,
        name,
        isAdmin,
        expires: new Date(expires),
      }
    }

    if (response.status === 401) {
      return {
        error: 'INVALID_CREDENTIALS',
      }
    }

    console.error('Unhandled error logging in', response.status)
    return {
      error: 'UNHANDLED_ERROR',
    }
  } catch (ex) {
    console.error('Unhandled error logging in', ex)
    return {
      error: 'UNHANDLED_ERROR',
    }
  }
}

export const logout = async () => {
  await fetch(`${apiHost}/api/v1/internal/logout`, {
    method: 'POST',
    credentials: 'include',
  })
}
